/* import __COLOCATED_TEMPLATE__ from './prism-radio-input.hbs'; */
import Component from '@ember/component';

/**
 * Use this component inside of a prism-form-group so that the radio options
 * will be linked. Ex:
 *
 * hbs
 * ```
 * {{#prism-form-group}}
 *   {{prism-radio-input
 *     inputClass="radio-button--upserve"
 *     inputId="bo-info__form__hasBeneficialOwners--yes"
 *     groupValue=(readonly businessHasBeneficialOwners)
 *     value=true
 *     label=(t "apply.boInfo.applicantOwnership.yes")
 *     onChange=(action (mut businessHasBeneficialOwners))}}
 *
 *   {{prism-radio-input
 *     inputClass="radio-button--upserve"
 *     inputId="bo-info__form__hasBeneficialOwners--no"
 *     groupValue=(readonly businessHasBeneficialOwners)
 *     value=false
 *     label=(t "apply.boInfo.applicantOwnership.no")
 *     onChange=(action (mut businessHasBeneficialOwners))}}
 * {{/prism-form-group}}
 * ```
 *
 * To apply custom styling, pass in a class to override
 * `.prism-radio`. Ex:
 *
 * hbs
 * ```
 *
 * @class PrismRadioInput
 */
export default Component.extend({
  classNames: ['prism-radio'],
  /**
   * The value associated with this radio input.
   *
   * @argument value
   * @type {any}
   */
  value: null,
  /**
   * The value bound to the set of radio inputs.
   *
   * @argument groupValue
   * @type {any}
   */
  groupValue: null,
  /**
   * Controls disabled state of the radio input.
   *
   * @argument disabled
   * @type {Boolean}
   */
  disabled: false,
  /**
   * Name for the radio input.
   *
   * @argument name
   * @type {String}
   */
  name: null,
  /**
   * ID for the radio input. Required.
   *
   * @argument inputId
   * @type {String}
   */
  inputId: null,
  /**
   * Class to apply to the radio input.
   *
   * @argument inputClass
   * @type {String}
   */
  inputClass: '',
  /**
   * Label to apply to the radio input.
   *
   * @argument label
   * @type {String}
   */
  label: null,
  /**
   * ID for the label if present. Required if a label is present.
   *
   * @argument labelId
   * @type {String}
   */
  labelId: null,
  /**
   * Class to apply to the radio input label.
   *
   * @argument labelClass
   * @type {String}
   */
  labelClass: '',
  /**
   * Action called when the value of the radio changes.
   *
   * @argument onChange
   * @type {action}
   */
  onChange() {},
  _changed(value) {
    this.onChange(value);
  }
});